<div id="header" *ngIf="showHeader">
  <div class="bounce-logo"></div>
  <div class="savvas-logo"></div>
</div>
